export const copy = {
  pt: {
    eyebrow: "Moda Feminina",
    coming: "Coming Soon · 2026",
    tagline: "Mais que moda, uma assinatura de estilo.",
    intro:
      "Seja a primeira a saber quando a CARMO abrir as portas. Deixe seu e-mail e receba o convite de lançamento.",
    placeholder: "Seu melhor e-mail",
    button: "Avise-me",
    sending: "Enviando…",
    successTitle: "Você está na lista.",
    successText: "Enviamos uma confirmação para o seu e-mail. Até breve.",
    alreadyTitle: "Você já está na lista.",
    alreadyText: "Esse e-mail já foi cadastrado. Nos vemos no lançamento.",
    invalid: "Digite um e-mail válido.",
    error: "Algo deu errado. Tente novamente.",
    caption: "Editorial — CARMO, 2026",
    rights: "© 2026 CARMO. Todos os direitos reservados.",
    admin: "Admin",
    marquee: "Coming Soon · 2026 · Mais que moda, uma assinatura de estilo · ",
  },
  en: {
    eyebrow: "Womenswear",
    coming: "Coming Soon · 2026",
    tagline: "More than fashion, a signature of style.",
    intro:
      "Be the first to know when CARMO opens its doors. Leave your email and receive the launch invitation.",
    placeholder: "Your best email",
    button: "Notify me",
    sending: "Sending…",
    successTitle: "You're on the list.",
    successText: "We've sent a confirmation to your email. See you soon.",
    alreadyTitle: "You're already on the list.",
    alreadyText: "This email is already registered. See you at launch.",
    invalid: "Please enter a valid email.",
    error: "Something went wrong. Please try again.",
    caption: "Editorial — CARMO, 2026",
    rights: "© 2026 CARMO. All rights reserved.",
    admin: "Admin",
    marquee: "Coming Soon · 2026 · More than fashion, a signature of style · ",
  },
};
